import Axios from 'axios';
import {
    store
} from '../store/store';
import {
    ADD_ACTIVE_REQUESTS,
    SUB_ACTIVE_REQUESTS
} from '../store/commitTypes';
const BASE_URL = 'web/v2/';
const axios = Axios.create({
    baseURL: BASE_URL
});


axios.interceptors.request.use(config => {
    store.commit(ADD_ACTIVE_REQUESTS);
    return config;
}, error => Promise.reject(error));

axios.interceptors.response.use(response => {
    store.commit(SUB_ACTIVE_REQUESTS);
    return response;
}, error => {
    return new Promise((resolve, reject) => {
        const {
            config,
            response
        } = error;
        const originalRequest = config;
        if (response && response.status === 419) {
            Axios.get('regenerate-session')
                .then(response => {
                    const newToken = response.data;
                    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = newToken;
                    document.querySelector('meta[name=csrf-token]').setAttribute('content', newToken);
                    originalRequest.headers['X-CSRF-TOKEN'] = newToken;
                    const newUrl = originalRequest.url.replace(BASE_URL, '');
                    originalRequest.url = newUrl;
                    // resolve(window.axios({
                    //     method: originalRequest.method,
                    //     url: originalRequest.url,
                    //     data: originalRequest.data
                    // }));
                    resolve(axios(originalRequest));
                });
            //toastr.error('Su sesión ha expirado, por favor refresque la página e intente nuevamente');
        } else {
            reject(error);
        }
    });
});

export {
    axios
};
